// src/pages/dashboard/BotControl.jsx
import React from 'react';

const BotControl = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-2">🤖 Bot Control Panel</h2>
      <p className="text-sm text-gray-300">
        Start, pause, or change strategies of your trading bot from here. Controls will appear soon.
      </p>
    </div>
  );
};

export default BotControl;
